export default __webpack_public_path__ + "static/bm-signature-new-gold-bd8d91e0db8872ddd90a698fd80532a0.png";